import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: { EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

const urls = {
  personalizedRecPreference: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/waterfall/personalizedRecPreference`, // Personalized content recommendation
  getCustomerServiceConfig: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/cs/getCustomerServiceConfig`, // Obtain CS related configurations
  createClick2Call: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/customer/createClick2Call`, // Amazon Contact Me
  createAccountDelete: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/intakeAcdd`, // Create DataDeletionRequest
  cancelAccountDelete: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/intakeAcdd/cancel`, //  Cancel DataDeletionRequest at customer consent step
  confirmAccountDelete: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/intakeAcdd/confirm`, // Accept DataDeletionRequest
  reviewAccountDelete: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/acdd/review`, // Review DataDeletionRequest
  reviewCancelAccountDelete: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/acdd/cancel`, // Cancel DataDeletionRequest at review step
  getCategoryDSAR: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/dsar/category`, // Get DSAR Categories
  requestDSAR: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/dsar/request`, // request DSAR
  confirmDSAR: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/dsar/confirm`, // Confirm DSAR request
  viewDSAR: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/dsar/view`,
  downloadDSAR: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/privacy/dsar/download`, // download DSAR
  getNotificationInAppCategory: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/notification/inApp/categories`, // message categories
  getNotificationInAppList: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/notification/inApp/list`, // message list
  getNotificationDetail: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/notification/inApp/detail`, // message detail
  updateReadStatus: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/notification/inApp/updateReadStatus`, // message update status
  getPersonalRecommend: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/content/getPersonalRecommend`,
  setPersonalRecommend: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/content/setPersonalRecommend`
};

export const getPersonalizedRecPreference = params =>
  aHttp.get(urls.personalizedRecPreference, params);
export const setPersonalizedRecPreference = params =>
  aHttp.put(urls.personalizedRecPreference, params);
export const getCustomerServiceConfig = params =>
  aHttp.get(urls.getCustomerServiceConfig, params);
export const createClick2Call = params =>
  aHttp.get(urls.createClick2Call, params);
export const createAccountDelete = params =>
  aHttp.post(urls.createAccountDelete, params);
export const cancelAccountDelete = params =>
  aHttp.post(urls.cancelAccountDelete, params);
export const confirmAccountDelete = params =>
  aHttp.post(urls.confirmAccountDelete, params);
export const reviewAccountDelete = params =>
  aHttp.post(urls.reviewAccountDelete, params);
export const reviewCancelAccountDelete = params =>
  aHttp.post(urls.reviewCancelAccountDelete, params);
export const getCategoryDSAR = params =>
  aHttp.get(urls.getCategoryDSAR, params);
export const getRequestDSAR = params => aHttp.post(urls.requestDSAR, params);
export const confirmDSAR = params => aHttp.post(urls.confirmDSAR, params);
export const viewDSAR = params => aHttp.post(urls.viewDSAR, params);
export const downloadDSAR = params => aHttp.post(urls.downloadDSAR, params);
export const getNotificationInAppCategory = params =>
  aHttp.get(urls.getNotificationInAppCategory, params);
export const getNotificationInAppList = params =>
  aHttp.get(urls.getNotificationInAppList, params);
export const getNotificationDetail = params =>
  aHttp.get(urls.getNotificationDetail, params);
export const updateReadStatus = params =>
  aHttp.post(urls.updateReadStatus, params);
export const getPersonalRecommend = (params, header = {}) =>
  aHttp.get(urls.getPersonalRecommend, params, header);
export const setPersonalRecommend = (params, header = {}) =>
  aHttp.post(urls.setPersonalRecommend, params, header);
